const leaveConfirm = {
  cancelText: 'no',
  okText: 'yes',
  content: 'Do you want to save before leave?',
};

const deletePhaseConfirm = {
  cancelText: 'no',
  okText: 'yes',
  content:
    'This will delete the full section of text. Are you sure you want to proceed?',
};
const deleteNodeConfirm = {
  cancelText: 'no',
  okText: 'yes',
  content:
    'This will delete the full sub-section of text. Are you sure you want to proceed?',
};

const emptyAlert = {
  okText: 'ok',
  content:
    'Please input a title or text for each M&A Lifecycle section / subsection before saving!',
};
const lastPhaseAlert = {
  okText: 'ok',
  content: 'You cannot delete the the last section!',
};
const lastNodeAlert = {
  okText: 'ok',
  content: 'You cannot delete the last subsection!',
};

export default {
  leaveConfirm,
  deleteNodeConfirm,
  deletePhaseConfirm,
  emptyAlert,
  lastPhaseAlert,
  lastNodeAlert,
};
